window.appVersion = "_endeksa_vernum_";
window.prerenderReady = false;

"use strict";
(function () {

    // Dynamic Manifest Selection for Multi-Language PWA Support
    window.setDynamicManifest = function () {
        var manifestLink = document.getElementById('app-manifest');
        if (!manifestLink) return;

        var lang = getManifestLanguage();

        // Map language to appropriate manifest file
        var manifestMap = {
            'en': '/site-en.webmanifest',
            'es-ES': '/site-es.webmanifest',
            'pt-PT': '/site-pt.webmanifest',
            'tr': '/site.webmanifest'
        };

        manifestLink.href = manifestMap[lang] || '/site.webmanifest';
    };

    function getManifestLanguage() {
        // Priority 1: Check URL path (e.g., /en/..., /tr/..., /es-ES/..., /pt-PT/...)
        var path = window.location.pathname;
        var urlLangMatch = path.match(/^\/(tr|en|es-ES|pt-PT)\//);
        if (urlLangMatch) {
            return urlLangMatch[1];
        }

        // Priority 2: Check localStorage (user preference or from main app)
        var storedLang = localStorage.getItem('endeksaLanguage') || localStorage.getItem('language');
        if (storedLang && (storedLang === 'tr' || storedLang === 'en' || storedLang === 'es-ES' || storedLang === 'pt-PT')) {
            return storedLang;
        }

        // Priority 3: Check browser language
        var browserLang = navigator.language || navigator.userLanguage;
        if (browserLang) {
            // Check exact match
            if (browserLang === 'tr' || browserLang === 'en' || browserLang === 'es-ES' || browserLang === 'pt-PT') {
                return browserLang;
            }
            // Check base language (e.g., 'en' from 'en-US')
            var baseLang = browserLang.split('-')[0];
            if (baseLang === 'en') return 'en';
            if (baseLang === 'es') return 'es-ES';
            if (baseLang === 'pt') return 'pt-PT';
            if (baseLang === 'tr') return 'tr';
        }

        // Default: Turkish
        return 'tr';
    }


    // window.interestValues = {
    //     rates: [
    //         { min: 10000, max: 150000, barrier: 120, lowerRate: 0.0277, higherRate: 0.0333 },
    //         { min: 150001, max: 750000, barrier: 120, lowerRate: 0.0273, higherRate: 0.0329 },
    //         { min: 750001, max: 3000000, barrier: 120, lowerRate: 0.0277, higherRate: 0.0333 }
    //     ],
    //     lowest: 10000,
    //     highest: 5000000,
    //     ratio: 0.80,
    //     apprisal: 2850,
    //     process: 0.005,
    //     expense: 300
    // };

    window.interestValuesAkbank = {
        types: [
            {
                type: 'insured',
                rates: [
                    { barrier: 36, rate: 4.35 },
                    { barrier: 72, rate: 3.50 },
                    { barrier: 120, rate: 3.05 }
                ]
            },
            {
                type: 'uninsured',
                rates: [
                    { barrier: 36, rate: 4.58 },
                    { barrier: 72, rate: 3.73 },
                    { barrier: 120, rate: 3.28 }
                ]
            }
        ],
        lowest: 10000,
        highest: 5000000,
        appraisal: 7700,
        fee: 1620
    };

    window.getMortgageRate = function (obj, type, term) {
        let typeObj = obj.types.find(function (t) {
            return t.type === type;
        });

        let mortgageRate = null;

        if (typeObj) {
            for (let i = 0; i < typeObj.rates.length; i++) {
                if (term <= typeObj.rates[i].barrier) {
                    mortgageRate = typeObj.rates[i].rate;
                    break;
                }
            }
        }

        return mortgageRate;
    };

    window.PopupCenter = function (url, title, w, h) {
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = width / 2 - w / 2 + dualScreenLeft;
        var top = height / 2 - h / 2 + dualScreenTop;
        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left + ',directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,noreferrer,noopener,popup');

        if (window.focus && newWindow) {
            newWindow.focus();
        }
    };

    // window.Timer = function (callback, delay) {
    //     var timerId, start, remaining = delay;

    //     this.pause = function () {
    //         window.clearTimeout(timerId);
    //         remaining -= Date.now() - start;
    //     };

    //     this.resume = function () {
    //         start = Date.now();
    //         window.clearTimeout(timerId);
    //         timerId = window.setTimeout(callback, remaining);
    //     };

    //     this.resume();
    // };

    window.makeid = function (length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    };

    window.getImgDimensions = function (data) {
        return new Promise(function (resolve, reject) {
            let img = new Image();
            img.src = data;
            img.decode().then(() => {
                let width = img.width;
                let height = img.height;
                resolve({
                    width: width,
                    height: height
                });
            }).catch(function (err) {
                resolve({});
            });
        });
    };

    window.getUrlParameter = function (sParam, decodedResponse = false) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                if (sParameterName[1] === undefined) {
                    return true;
                }
                return decodedResponse ? decodeURIComponent(sParameterName[1]) : sParameterName[1];
            }
        }
    };

    if (typeof Object.defineProperty === 'function') {
        try { Object.defineProperty(Array.prototype, 'sortBy', { value: sb }); } catch (e) {
            //ignored
        }
    }
    if (!Array.prototype.sortBy) Array.prototype.sortBy = sb;

    function sb(f) {
        for (var i = this.length; i;) {
            var o = this[--i];
            this[i] = [].concat(f.call(o, o, i), o);
        }
        this.sort(function (a, b) {
            for (var i = 0, len = a.length; i < len; ++i) {
                if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
            }
            return 0;
        });
        for (var u = this.length; u;) {
            this[--u] = this[u][this[u].length - 1];
        }
        return this;
    }

    Array.prototype.sortByProperty = function (a) {
        return this.sortBy(function (o) { return !o[a]; });
    };

    // locale specific chars
    // IMPORTANT: name of locale must be always in lower case (for "tr-TR" locale - "tr-tr") !!!
    var localeInfos = {
        "tr-tr": {
            lower: { "i": "İ", "ı": "I", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ç": "Ç", "ö": "Ö", 'í': "İ" },
            upper: { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ç": "ç", "Ö": "ö", 'İ̇': "i" }
        }
    },
        localeInfo;

    // helper vars
    var mask_local = "\\s:\\-", // add additional delimeters chars to the mask if needed
        rg_local = new RegExp("([^" + mask_local + "])([^" + mask_local + "]*)", "g");
    var fnToLocaleLower = function (s) {
        if (localeInfo) {
            var localeInfosKeys = Object.keys(localeInfos);
            for (var i = 0; localeInfo === localeInfos[localeInfosKeys[i]]; i++) {
                localeInfo.lowerSearchRegExp = new RegExp("[" + Object.keys(localeInfo.lower).join("") + "]", "g");
                localeInfo.upperSearchRegExp = new RegExp("[" + Object.keys(localeInfo.upper).join("") + "]", "g");
            }
        }
        return localeInfo.upper[s];
    },
        fnToLocaleUpper = function (s) {
            if (localeInfo) {
                var localeInfosKeys = Object.keys(localeInfos);
                for (var i = 0; localeInfo === localeInfos[localeInfosKeys[i]]; i++) {
                    localeInfo.lowerSearchRegExp = new RegExp("[" + Object.keys(localeInfo.lower).join("") + "]", "g");
                    localeInfo.upperSearchRegExp = new RegExp("[" + Object.keys(localeInfo.upper).join("") + "]", "g");
                }
            }
            return localeInfo.lower[s];

        },
        fnToProper = function ($0, $1, $2) {
            if (localeInfo) {
                var localeInfosKeys = Object.keys(localeInfos);
                for (var i = 0; localeInfo === localeInfos[localeInfosKeys[i]]; i++) {
                    localeInfo.lowerSearchRegExp = new RegExp("[" + Object.keys(localeInfo.lower).join("") + "]", "g");
                    localeInfo.upperSearchRegExp = new RegExp("[" + Object.keys(localeInfo.upper).join("") + "]", "g");
                }
                if (localeInfo.lower.hasOwnProperty($1)) $1 = localeInfo.lower[$1];
                $2 = $2.replace(localeInfo.upperSearchRegExp, fnToLocaleLower);
            }
            return $1.toUpperCase() + $2.toLowerCase();
        };

    // extending String.prototype
    String.prototype.toLocaleProperCase2 = function toLocaleProperCase2(locale) {
        localeInfo = localeInfos[arguments.length ? locale.toLowerCase() : null];
        return this.replace(rg_local, fnToProper).replace(/i̇/g, 'i').replace(/undefined/g, '');
    };
    String.prototype.toLocaleLowerCase2 = function toLocaleLowerCase2(locale) {
        return ((localeInfo = localeInfos[arguments.length ? locale.toLowerCase() : null]) ?
            this.replace(localeInfo.upperSearchRegExp, fnToLocaleLower) :
            this).replace(/i̇/g, 'i').toLowerCase();
    };
    String.prototype.toLocaleUpperCase2 = function toLocaleUpperCase2(locale) {
        return ((localeInfo = localeInfos[arguments.length ? locale.toLowerCase() : null]) ?
            this.replace(localeInfo.lowerSearchRegExp, fnToLocaleUpper) :
            this).replace(/i̇/g, 'i').toUpperCase();
    };

    Number.prototype.countDecimals = function () {
        if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
        return this.toString().split(".")[1].length || 0;
    };

    Number.prototype.formatMoney = function (c, d, t) {
        var n = this;
        c = isNaN(c = Math.abs(c)) ? 2 : c;
        d = d == undefined ? "," : d;
        t = t == undefined ? "." : t;
        var s = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    };

    String.prototype.toUnicode = function () {
        var theString = this;
        var unicodeString = '';
        for (var i = 0; i < theString.length; i++) {
            var theUnicode = theString.charCodeAt(i).toString(16).toUpperCase();
            while (theUnicode.length < 4) {
                theUnicode = '0' + theUnicode;
            }
            theUnicode = '\\u' + theUnicode;
            unicodeString += theUnicode;
        }
        return unicodeString;
    };

    Number.prototype.countDecimals = function () {
        if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
        return this.toString().split(".")[1].length || 0;
    };

    String.prototype.norm_to_ascii = function () { return unescape(encodeURIComponent(this)); };
    String.prototype.norm_to_unicode = function () { return decodeURIComponent(escape(this)); };
    String.prototype.crypt_sym = function (k) { return String.fromCharCode.apply(undefined, this.split("").map(function (c) { return c.charCodeAt(0) ^ (k || 13); })); };

    // window.encryptObject = function (osd) {
    //     try {
    //         var cryption = JSON.stringify(osd).replace(/\,/g, 'DD').replace(/\"/g, 'RR').replace(/\./g, 'PP').replace(/\(/g, 'UU').replace(/\)/g, 'VV').replaceAllString('{', 'ZZ').replaceAllString('}', 'XX').replaceAllString(':', 'YY');
    //         var e = encodeURIComponent(btoa(cryption.norm_to_ascii().crypt_sym()));
    //         return e;
    //     } catch (err) {
    //         return null;
    //     }
    // };
    // window.decryptObject = function (e) {
    //     try {
    //         var z = decodeURIComponent(e);
    //         return JSON.parse(atob(z).norm_to_unicode().crypt_sym().replaceAllString('DD', ',').replaceAllString('RR', '"').replaceAllString('PP', '.').replaceAllString('UU', '(').replaceAllString('VV', ')').replaceAllString('ZZ', '{').replaceAllString('XX', '}').replaceAllString('YY', ':'));
    //     } catch (err) {
    //         return null;
    //     }
    // };

    window.isMobileOrTablet = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        if (navigator && navigator.platform && navigator.maxTouchPoints && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
            check = true;
        return check;
    };

    window.isMobile = function () {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    window.isHeadless = function () {
        return /HeadlessChrome/.test(window.navigator.userAgent) || (eval.toString().length == 33 && !window.chrome);
    };

    window.compressBase64Image = function (data, quality = 1, width = 800, height = 800) {
        let canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        let ctx = canvas.getContext("2d");
        let image = new Image();
        image.src = data;

        ctx.drawImage(image, 0, 0);

        let url = canvas.toDataURL('image/jpeg', quality);

        return url;
    };

    Array.prototype.contains = function (needle) {
        for (i = 0; i < this.length; i++) {
            if (this[i].indexOf(needle) > -1) return this[i];
        }
        return null;
    };


    Array.prototype.sum = function (prop, timeStart, timeEnd) {
        var total = 0;
        for (var i = 0, _len = this.length; i < _len; i++) {
            if (this[i].date && timeStart && timeEnd) {
                var compare = moment(this[i].date, 'DD.MM.YYYY');
                if (timeStart > compare || timeEnd < compare)
                    continue;
            }
            total += this[i][prop];
        }
        return total;
    };

    Array.prototype.groupBy = function (key, count, timeStart, timeEnd) {
        var xs = this;
        return xs.reduce(function (rv, x) {
            if (x.date && timeStart && timeEnd) {
                var compare = moment(x.date, 'DD.MM.YYYY');
                if (timeStart > compare || timeEnd < compare)
                    return rv;
            }

            var array = (rv[x[key]] = rv[x[key]] || {});
            array.text = x[key];
            array.nodes = array.nodes || [];
            array.nodes.push(x);
            if (count)
                array.sum = array.nodes.sum(count);
            return rv;
        }, {});
    };

    Array.prototype.groupByDate = function (key, count, format, timeStart, timeEnd) {
        var xs = this;
        return xs.reduce(function (rv, x) {
            format = format || 'MM-YYYY';
            var compare = moment(x[key], 'DD.MM.YYYY');
            var t = compare.format(format);
            if (timeStart && timeEnd && (timeStart > compare || timeEnd < compare))
                return rv;
            var array = (rv[t] = rv[t] || {});
            array.text = x[key];
            array.format = t;
            array.nodes = array.nodes || [];
            array.nodes.push(x);
            if (count)
                array.sum = array.nodes.sum(count);
            return rv;
        }, {});
    };

    Array.prototype.diff = function (a) {
        return this.filter(function (i) { return a.indexOf(i) < 0; });
    };

    Array.prototype.sortOn = function (key) {
        this.sort(function (a, b) {
            if (a[key] < b[key]) {
                return -1;
            } else if (a[key] > b[key]) {
                return 1;
            }
            return 0;
        });
    };

    Array.prototype.clean = function (deleteValue) {
        for (var i = 0; i < this.length; i++) {
            if (this[i] === deleteValue) {
                this.splice(i, 1);
                i--;
            }
        }
        return this;
    };

    String.prototype.replaceAllString = function (search, replacement) {
        var target = this;
        // return target.replace(new RegExp(search, 'g'), replacement);
        var escapedSearch = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        return target.replace(new RegExp(escapedSearch, 'g'), replacement);
    };

    String.prototype.replaceHtmlEntities = function () {
        var translate_re = /&(nbsp|amp|quot|lt|gt|rsquo);/g,
            translate = {
                'nbsp': String.fromCharCode(160),
                'amp': '&',
                'quot': '"',
                'lt': '<',
                'gt': '>',
                'rsquo': String.fromCharCode(39)
            },
            translator = function ($0, $1) {
                return translate[$1];
            };
        var target = this;
        return target.replace(translate_re, translator);
    };

    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }



    window.exportWord = function (wrapperId, filename) {
        if (window.userStorage.getItem('demo')) {
            alert("Demo hesaplarda bu özellik kullanılamamaktadır. Lütfen satış yöneticiniz ile iletişime geçiniz.");
            return false;
        }
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
            "xmlns:w='urn:schemas-microsoft-com:office:word' " +
            "xmlns='http://www.w3.org/TR/REC-html40'>" +
            "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var sourceHTML = header + document.getElementById(wrapperId).innerHTML + footer;

        var dataType = 'application/vnd.ms-word';

        // Specify file name
        filename = filename ? 'Endeksa - ' + document.getElementById(filename).innerText.trim() + '.doc' : 'document.doc';

        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);


        if (navigator.msSaveOrOpenBlob) {
            var blob = new Blob(['\ufeff', sourceHTML], {
                type: dataType
            });
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            fileDownload.href = source;
            fileDownload.download = filename;
            fileDownload.click();
            document.body.removeChild(fileDownload);
        }
    };


    window.exportExcel = function (table, name) {
        if (window.userStorage.getItem('demo')) {
            alert("Demo hesaplarda bu özellik kullanılamamaktadır. Lütfen satış yöneticiniz ile iletişime geçiniz.");
            return false;
        }
        var uri = 'data:application/vnd.ms-excel;base64,',
            template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))); },
            format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }); };


        if (!table.nodeType) table = document.getElementById(table);

        var filename = name ? 'Endeksa - ' + document.getElementById(name).innerText.trim() : 'excel_data';

        name = name ? document.getElementById(name).innerText.trim() : 'analysis';

        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };

        //window.location.href = uri + base64(format(template, ctx))

        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        // Create a link to the file
        downloadLink.href = uri + base64(format(template, ctx));

        // Setting the file name
        downloadLink.download = filename + ".xls";



        //triggering the function
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    window.exportPNG = function (tableID, filename, el) {
        if (window.userStorage.getItem('demo')) {
            alert("Demo hesaplarda bu özellik kullanılamamaktadır. Lütfen satış yöneticiniz ile iletişime geçiniz.");
            return false;
        }
        $(el).hide();
        modernScreenshot.domToPng(document.getElementById(tableID))
            .then(function (dataUrl) {
                var link = document.createElement('a');
                $(el).show();
                // Specify file name
                filename = filename ? 'Endeksa - ' + document.getElementById(filename).innerText.trim() + '.png' : 'image.png';

                link.download = filename;
                link.href = dataUrl;
                link.click();
            }).catch(function (error) {
                $(el).show();
                console.error('oops, something went wrong!', error);
            });

    };

    window.exportJpeg = function (tableID, filename, el) {
        if (window.userStorage.getItem('demo')) {
            alert("Demo hesaplarda bu özellik kullanılamamaktadır. Lütfen satış yöneticiniz ile iletişime geçiniz.");
            return false;
        }
        $(el).hide();
        modernScreenshot.domToJpeg(document.getElementById(tableID), { quality: 1 })
            .then(function (dataUrl) {
                var link = document.createElement('a');
                $(el).show();
                // Specify file name
                filename = filename ? 'Endeksa - ' + document.getElementById(filename).innerText.trim() + '.jpeg' : 'image.jpeg';

                link.download = filename;
                link.href = dataUrl;
                link.click();
            }).catch(function (error) {
                $(el).show();
                console.error('oops, something went wrong!', error);
            });

    };

    // window.checkCookie_eu = function () {

    //     var consent = getCookie_eu("cookies_consent");

    //     if ((consent == null || consent == "" || consent == undefined) && window.location.href.indexOf('quake') === -1) {
    //         // show notification bar
    //         $('#cookie_directive_container').fadeIn();
    //     }
    //     else {
    //         $('#cookie_directive_container').remove();
    //     }

    // };

    window.setTimeout(function () {
        // if (!window.isHeadless())
        //     window.checkCookie_eu();

        if (window.getUrlParameter('top') || window.isHeadless()) {
            var sheet = window.document.styleSheets[0];
            sheet.insertRule('#loading-bar { display: none !important; }', sheet.cssRules.length);
        }

        if (window.isHeadless()) {
            //Prerendered page css fix
            const date = new Date();
            const month = date.getUTCMonth() + 1;
            const year = date.getUTCFullYear();
            const newdate = year + "." + month;
            $('#css-fonts').attr('href', 'https://cdn.endeksa.com/fonts/fonts.min.css?d=' + newdate);
            $('#css-vendor').attr('href', 'https://cdn.endeksa.com/css/vendor.core.min.css?d=' + newdate);
            $('#css-main').attr('href', 'https://cdn.endeksa.com/css/main.core.min.css?d=' + newdate);
        }
    }, 100);

    // function setCookie_eu(c_name, value, exdays) {

    //     var exdate = new Date();
    //     exdate.setDate(exdate.getDate() + exdays);
    //     var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    //     document.cookie = c_name + "=" + c_value + "; path=/";

    //     $('#cookie_directive_container').fadeOut(function () {
    //         $('#cookie_directive_container').remove();
    //     });
    // }


    // function getCookie_eu(c_name) {
    //     var i, x, y, ARRcookies = document.cookie.split(";");
    //     for (i = 0; i < ARRcookies.length; i++) {
    //         x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    //         y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    //         x = x.replace(/^\s+|\s+$/g, "");
    //         if (x == c_name) {
    //             return unescape(y);
    //         }
    //     }
    // }

    // $("#cookie_accept a").click(function () {
    //     setCookie_eu("cookies_consent", 1, 30);
    // });
})();


var logonkey_ = [
    { ref: 'bank', top: '6896DRB2NNZUIELS', type: "bank" },
    { ref: 'gdys', top: '6896DRB2NNZJPLQD', type: "premium" },
    // { ref: 'ebis', top: 'FEHUBNX5TBCV2PC4', type: "advance" },
    { ref: 'geodi', top: 'UYLR0L4K03LU3GMG', type: "advance" },
    { ref: null, top: '6896DRB2NNZJPLQD', type: "none" },
    { ref: 'intern', top: '6896DRB2NNZJPLQD', type: "intern" },
    { ref: 'cbs', top: '9F4FF3SEHQ2A66YX', type: "intern" },
];

var toper_ = window.getUrlParameter('top');
var referer_ = window.getUrlParameter('ref');

for (var y = 0; y < logonkey_.length; y++) {
    var current = logonkey_[y];
    if (referer_ && current.ref === referer_ && current.top === toper_) {
        window.hasAllowance = current.type;
        window.topKey = current.top;
    }
    else if (!referer_ && current.top === toper_) {
        window.hasAllowance = current.type;
        window.topKey = current.top;
    }
}

window.ecSec = function () {
    var cliTime = Math.floor(new Date().getTime() / 1000);
    var timeDiff = (window.localStorage.getItem('time_diff') && !isNaN(window.localStorage.getItem('time_diff'))) ? +window.localStorage.getItem('time_diff') : 0;
    cliTime = cliTime - timeDiff;
    cliTime = cliTime.toString().slice(4);
    var rndSuffix = Math.floor(1000 + Math.random() * 9000);
    if (rndSuffix % 2 === 0) {
        var fPart = cliTime.slice(0, 3).split('').reverse().join('');
        var sPart = cliTime.slice(3).split('').reverse().join('');
        cliTime = fPart + sPart + rndSuffix;
    } else {
        cliTime += rndSuffix;
    }
    return cliTime;
};

function removeElementsWithValue(arr, val) {
    var i = arr.length;
    while (i--) {
        if (arr[i] === val) {
            arr.splice(i, 1);
        }
    }
    return arr;
}

function toWKT(layer) {
    var lng, lat, coords = [];
    if (L && (layer instanceof L.Polygon || layer instanceof L.Polyline)) {
        var latlngs = layer.getLatLngs();
        if (latlngs.length === 1)
            latlngs = layer.getLatLngs()[0];
        for (var i = 0; i < latlngs.length; i++) {
            // latlngs[i];
            coords.push(latlngs[i].lng + " " + latlngs[i].lat);
            if (i === 0) {
                lng = latlngs[i].lng;
                lat = latlngs[i].lat;
            }
        }
        if (layer instanceof L.Polygon) {
            return "POLYGON((" + coords.join(",") + "," + lng + " " + lat + "))";
        } else if (layer instanceof L.Polyline) {
            return "LINESTRING(" + coords.join(",") + ")";
        }
    } else if (L && layer instanceof L.Marker) {
        return "POINT(" + layer.getLatLng().lng + " " + layer.getLatLng().lat + ")";
    }
    else
        return "";
}

function removeDiacritics(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/Ğ/gim, "g")
        .replace(/Ü/gim, "u")
        .replace(/Ş/gim, "s")
        .replace(/I/gim, "i")
        .replace(/İ/gim, "i")
        .replace(/Ö/gim, "o")
        .replace(/Ç/gim, "c")
        .replace(/ğ/gim, "g")
        .replace(/ü/gim, "u")
        .replace(/ş/gim, "s")
        .replace(/ı/gim, "i")
        .replace(/ö/gim, "o")
        .replace(/ç/gim, "c")
        .replace(/i̇/gim, 'i');
    // var defaultDiacriticsRemovalMap = [
    //     { 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g },
    //     { 'base': 'AA', 'letters': /[\uA732]/g },
    //     { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g },
    //     { 'base': 'AO', 'letters': /[\uA734]/g },
    //     { 'base': 'AU', 'letters': /[\uA736]/g },
    //     { 'base': 'AV', 'letters': /[\uA738\uA73A]/g },
    //     { 'base': 'AY', 'letters': /[\uA73C]/g },
    //     { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g },
    //     { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g },
    //     { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g },
    //     { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g },
    //     { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g },
    //     { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g },
    //     { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
    //     { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g },
    //     { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g },
    //     { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g },
    //     { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
    //     { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g },
    //     { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g },
    //     { 'base': 'LJ', 'letters': /[\u01C7]/g },
    //     { 'base': 'Lj', 'letters': /[\u01C8]/g },
    //     { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g },
    //     { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g },
    //     { 'base': 'NJ', 'letters': /[\u01CA]/g },
    //     { 'base': 'Nj', 'letters': /[\u01CB]/g },
    //     { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g },
    //     { 'base': 'OI', 'letters': /[\u01A2]/g },
    //     { 'base': 'OO', 'letters': /[\uA74E]/g },
    //     { 'base': 'OU', 'letters': /[\u0222]/g },
    //     { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g },
    //     { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
    //     { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g },
    //     { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g },
    //     { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g },
    //     { 'base': 'TZ', 'letters': /[\uA728]/g },
    //     { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g },
    //     { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g },
    //     { 'base': 'VY', 'letters': /[\uA760]/g },
    //     { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g },
    //     { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
    //     { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g },
    //     { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g },
    //     { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g },
    //     { 'base': 'aa', 'letters': /[\uA733]/g },
    //     { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g },
    //     { 'base': 'ao', 'letters': /[\uA735]/g },
    //     { 'base': 'au', 'letters': /[\uA737]/g },
    //     { 'base': 'av', 'letters': /[\uA739\uA73B]/g },
    //     { 'base': 'ay', 'letters': /[\uA73D]/g },
    //     { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g },
    //     { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g },
    //     { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g },
    //     { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g },
    //     { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g },
    //     { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
    //     { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g },
    //     { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g },
    //     { 'base': 'hv', 'letters': /[\u0195]/g },
    //     { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g },
    //     { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
    //     { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g },
    //     { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g },
    //     { 'base': 'lj', 'letters': /[\u01C9]/g },
    //     { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g },
    //     { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g },
    //     { 'base': 'nj', 'letters': /[\u01CC]/g },
    //     { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g },
    //     { 'base': 'oi', 'letters': /[\u01A3]/g },
    //     { 'base': 'ou', 'letters': /[\u0223]/g },
    //     { 'base': 'oo', 'letters': /[\uA74F]/g },
    //     { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g },
    //     { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
    //     { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g },
    //     { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g },
    //     { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g },
    //     { 'base': 'tz', 'letters': /[\uA729]/g },
    //     { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g },
    //     { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g },
    //     { 'base': 'vy', 'letters': /[\uA761]/g },
    //     { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g },
    //     { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
    //     { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g },
    //     { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g },
    //     { 'base': '', 'letters': /[\(\)]/g },
    // ];

    // for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    //     str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
    // }

    // return str.replace(/i̇/g, 'i');

}

function normalizeAddress(add) {
    if (!add)
        return "";
    return removeDiacritics(add.replace(', Türkiye', ''))
        .replaceAllString('\"', '')
        .replaceAllString('\“', '')
        .replaceAllString('\”', '')
        .replaceAllString('\«', '')
        .replaceAllString('\»', '')
        .replaceAllString('\'', '')
        .replaceAllString(',', '')
        .replaceAllString(':', ' ')
        .replace(/\./g, '')
        .replaceAllString('/', ' ')
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-'); // replace spaces with hyphens
}

function getURLParam(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
}


$(document).ready(function () {
    $(document).on('click', function (e) {
        $('[data-toggle="popover"],[data-original-title]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false; // fix for BS 3.3.6
            }

        });
    });

});

// var OneSignal = OneSignal || [];


window.updateQueryStringParameter = function (uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    if (value === undefined) {
        if (uri.match(re)) {
            return uri.replace(re, '$1$2').replace(/[?&]$/, '').replaceAll(/([?&])&+/g, '$1').replace(/[?&]#/, '#');
        } else {
            return uri;
        }
    } else {
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            var hash = '';
            if (uri.indexOf('#') !== -1) {
                hash = uri.replace(/.*#/, '#');
                uri = uri.replace(/#.*/, '');
            }
            var separator = uri.indexOf('?') !== -1 ? "&" : "?";
            return uri + separator + key + "=" + value + hash;
        }
    }
};

window.encodeResponse = function (cipher) {
    if (cipher === null || cipher === undefined)
        return cipher;
    let secret = "3ND3KS4B4CK3ND24";
    let key = CryptoJS.enc.Utf8.parse(secret);
    let decryptedBytes = CryptoJS.AES.decrypt(cipher, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return decryptedBytes.toString(CryptoJS.enc.Utf8);
};

window.urlfx2 = window.location.host.indexOf('www') > -1 ? 'api' : (window.location.host.indexOf('beta') > -1 ? 'apibeta' : 'api');
window.userStorage = {
    synced: false,
    items: [],
    getItem: function (key) {
        var that = this;
        if (window.endeksa && window.endeksa.id && that.synced) {
            for (var y = 0; y < that.items.length; y++) {
                if (that.items[y].Key === key)
                    return that.items[y].Value;
            }
            return null;
        }
        else
            return window.localStorage.getItem(key);
    },
    setItem: function (key, value) {
        var that = this;
        var val = typeof value !== 'string' ? JSON.stringify(value) : value;
        if (key && val && window.endeksa && window.endeksa.id)
            $.ajax({
                type: 'POST',
                contentType: "application/json",
                dataType: 'json',
                url: 'https://' + window.urlfx2 + '.endeksa.com/userstorage?UserId=' + window.endeksa.id + '&key=' + key.toString() + '&value=' + val,
                success: function () {
                    var index = null;
                    for (var y = 0; y < that.items.length; y++) {
                        if (that.items[y].Key === key)
                            index = y;
                    }
                    if (index) {
                        that.items.splice(index, 1);
                    }
                    that.items.push({ Key: key.toString(), Value: val });
                }
            });
        window.localStorage.setItem(key, val);
    },
    removeItem: function (key) {
        var that = this;
        if (key && window.endeksa && window.endeksa.id)
            $.ajax({
                type: 'DELETE',
                contentType: "application/json",
                dataType: 'json',
                url: 'https://' + window.urlfx2 + '.endeksa.com/userstorage?UserId=' + window.endeksa.id + '&key=' + key.toString(),
                success: function () {
                    var index = null;
                    for (var y = 0; y < that.items.length; y++) {
                        if (that.items[y].Key === key)
                            index = y;
                    }
                    if (index) {
                        that.items.splice(index, 1);
                    }
                }
            });
        window.localStorage.removeItem(key);
    },
    sync: function () {
        var that = this;
        if (window.endeksa && window.endeksa.id) {
            $.ajax({
                type: 'GET',
                contentType: "application/json",
                dataType: 'json',
                url: 'https://' + window.urlfx2 + '.endeksa.com/userstorage?UserId=' + window.endeksa.id,
                success: function (data) {
                    that.items = data;
                    for (var y = 0; y < that.items.length; y++) {
                        if (that.items[y].Key.indexOf('leadshown') === -1)
                            window.localStorage.setItem(that.items[y].Key, that.items[y].Value);
                        else
                            that.removeItem(that.items[y].Key);
                    }
                    var keys = Object.keys(window.localStorage);
                    var itemkeys = that.items.map(function (a) { return a.Key; });
                    for (var j = 0; j < keys.length; j++) {
                        if (itemkeys.indexOf(keys[j]) === -1 && keys[j].indexOf('angular-cache') === -1 && (keys[j].indexOf('intro') > -1 || keys[j].indexOf('navstate') > -1 || keys[j].indexOf('map_') > -1 || keys[j].indexOf('top_') > -1))
                            that.setItem(keys[j], window.localStorage.getItem(keys[j]));
                    }
                    that.synced = true;
                }
            });
        }
    }
};


// Speed up calls to hasOwnProperty
window.isEmpty = function (obj) {
    if (!obj) return true;
    if (obj.length) return false;
    if (obj.length === 0) return true;
    if (typeof obj !== "object") return true;
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }

    return true;
};

$.fn.followTo = function (top, fix) {
    if (this.length === 0)
        return false;
    var $this = this,
        $window = $(window),
        $startPos = $this.offset().top,
        $top = $this.css('top'),
        $position = $this.css('position'),
        $width = $this.css('width'),
        setPosition = function () {
            if ($window.scrollTop() < $startPos - top) {
                $this.css({
                    position: $position,
                    top: $top,
                    width: $width
                });
            } else {
                $this.css({
                    position: 'fixed',
                    top: top,
                    backgroundColor: 'white',
                    width: fix,
                    zIndex: 20000
                });
            }
        };
    $window.resize(function () {
        setPosition();
    });
    $window.scroll(setPosition);
    setPosition();
};

window.isHighDensity = function () {
    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
};


window.isRetina = function () {
    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
};

//=======================================
//              CHECK TC ID             =
//=======================================
window.checkTcNum = function (TCNO) {

    var tek = 0,
        cift = 0,
        sonuc = 0,
        TCToplam = 0,
        i = 0,
        hatali = [11111111110, 22222222220, 33333333330, 44444444440, 55555555550, 66666666660, 7777777770, 88888888880, 99999999990];

    if (isNaN(TCNO)) return false;

    TCNO = TCNO.toString();

    if (TCNO.length != 11) return false;
    if (TCNO[0] == 0) return false;

    tek = parseInt(TCNO[0]) + parseInt(TCNO[2]) + parseInt(TCNO[4]) + parseInt(TCNO[6]) + parseInt(TCNO[8]);
    cift = parseInt(TCNO[1]) + parseInt(TCNO[3]) + parseInt(TCNO[5]) + parseInt(TCNO[7]);

    tek = tek * 7;
    sonuc = Math.abs(tek - cift);
    if (sonuc % 10 != TCNO[9]) return false;

    for (var t = 0; t < 10; t++) {
        TCToplam += parseInt(TCNO[t]);
    }

    if (TCToplam % 10 != TCNO[10]) return false;

    if (hatali.toString().indexOf(TCNO) != -1) return false;

    return true;
};
//--------  End of check tc id  ---------//


window.isTaxNoValid = function vergikimlik(kno) {
    var v1 = 0;
    var v2 = 0;
    var v3 = 0;
    var v4 = 0;
    var v5 = 0;
    var v6 = 0;
    var v7 = 0;
    var v8 = 0;
    var v9 = 0;
    var v11 = 0;
    var v22 = 0;
    var v33 = 0;
    var v44 = 0;
    var v55 = 0;
    var v66 = 0;
    var v77 = 0;
    var v88 = 0;
    var v99 = 0;
    var v_last_digit = 0;
    var toplam = 0;


    if (kno.length === 10) {

        v1 = (Number(kno.charAt(0)) + 9) % 10;

        v2 = (Number(kno.charAt(1)) + 8) % 10;

        v3 = (Number(kno.charAt(2)) + 7) % 10;

        v4 = (Number(kno.charAt(3)) + 6) % 10;

        v5 = (Number(kno.charAt(4)) + 5) % 10;

        v6 = (Number(kno.charAt(5)) + 4) % 10;
        v7 = (Number(kno.charAt(6)) + 3) % 10;
        v8 = (Number(kno.charAt(7)) + 2) % 10;
        v9 = (Number(kno.charAt(8)) + 1) % 10;
        v_last_digit = Number(kno.charAt(9));

        v11 = (v1 * 512) % 9;
        v22 = (v2 * 256) % 9;
        v33 = (v3 * 128) % 9;
        v44 = (v4 * 64) % 9;
        v55 = (v5 * 32) % 9;
        v66 = (v6 * 16) % 9;
        v77 = (v7 * 8) % 9;
        v88 = (v8 * 4) % 9;
        v99 = (v9 * 2) % 9;

        if (v1 != 0 && v11 == 0) v11 = 9;
        if (v2 != 0 && v22 == 0) v22 = 9;
        if (v3 != 0 && v33 == 0) v33 = 9;
        if (v4 != 0 && v44 == 0) v44 = 9;
        if (v5 != 0 && v55 == 0) v55 = 9;
        if (v6 != 0 && v66 == 0) v66 = 9;
        if (v7 != 0 && v77 == 0) v77 = 9;
        if (v8 != 0 && v88 == 0) v88 = 9;
        if (v9 != 0 && v99 == 0) v99 = 9;
        toplam = v11 + v22 + v33 + v44 + v55 + v66 + v77 + v88 + v99;


        if (toplam % 10 == 0) toplam = 0;
        else toplam = (10 - (toplam % 10));

        if (toplam == v_last_digit) {


            return true;
        } else return false;

    } else return false;

};


window.getCookieValue = function (a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
};


window.cekimEki = function (metin, ekler) {
    if (window.lang !== 'tr')
        return metin;
    else if (window.lang !== 'tr' && ekler === 'de')
        ekler = 's';
    if (!metin || !ekler)
        return "";
    ekler = ekler.replace(/\s/g, '');
    var ekler_dizisi = ekler.split(",");
    var cogul_mu = false;
    var kesme_isareti = false;
    var ozel_isim_mi = false;
    var yabanci_mi = false;

    var metin_dizisi = metin.split("|");

    if (typeof metin_dizisi[1] !== "undefined") {
        if (metin_dizisi[1] == "y") {
            yabanci_mi = true;
        }
    }

    metin = metin_dizisi[0];

    ekler_dizisi = ekleriSirala(ekler_dizisi);

    if (/^[A-ZİÖÜĞŞÇ]/.test(metin)) {
        metin = metin.replace(/[A-ZİÖÜĞŞÇ]\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
        ozel_isim_mi = true;
    }

    for (var i = 0; i < ekler_dizisi.length; i++) {

        if (ekler_dizisi[i] == "lar" || ekler_dizisi[i] == "ler") {
            metin = _ler(metin, ozel_isim_mi);
            cogul_mu = true;
        }
        if (ekler_dizisi[i] == "ın" || ekler_dizisi[i] == "in" || ekler_dizisi[i] == "un" || ekler_dizisi[i] == "ün") { metin = _in(metin, ozel_isim_mi, yabanci_mi); }
        if (ekler_dizisi[i] == "a" || ekler_dizisi[i] == "e" || ekler_dizisi[i] == "u" || ekler_dizisi[i] == "ü") { metin = _e(metin, ozel_isim_mi, yabanci_mi); }
        if (ekler_dizisi[i] == "ı" || ekler_dizisi[i] == "i" || ekler_dizisi[i] == "u" || ekler_dizisi[i] == "ü") { metin = _i(metin, ozel_isim_mi, yabanci_mi); }
        if (ekler_dizisi[i] == "da" || ekler_dizisi[i] == "de" || ekler_dizisi[i] == "ta" || ekler_dizisi[i] == "te" || ekler_dizisi[i] == "s" ||
            ekler_dizisi[i] == "dan" || ekler_dizisi[i] == "den" || ekler_dizisi[i] == "tan" || ekler_dizisi[i] == "ten") { metin = _de_den(metin, ekler_dizisi[i], ozel_isim_mi); }
    }

    return metin;


    function _ler(metin) { // Çokluk (Çoğul) Eki (-lar / -ler)

        if (ozel_isim_mi && !kesme_isareti) {
            metin = ozelIsim(metin, true);
            kesme_isareti = true;
        }

        if (metin.match(/[aıou]$|[aıou][bcçdfgğhjklmnprsştvwxyz']$|[aıou][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz]$/i)) {
            metin += "lar";
        }
        if (metin.match(/[eiöü]$|[eiöü][bcçdfgğhjklmnprsştvwxyz']$|[eiöü][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz]$/i)) {
            metin += "ler";
        }

        return metin;
    }


    function _in(metin, ozel_isim_mi, yabanci_mi) { // İlgi (Tamlama) Ekleri (-ın / -in / -un / -ün)
        if (metin === "ben") { return "benim"; } // Özel Kural
        if (metin === "biz") { return "bizim"; } // Özel Kural
        if (metin.match(/.*[aeoueıiöü]$/i)) {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            }
            metin += "n";
        } else {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            } else if (!ozel_isim_mi && !yabanci_mi) {
                metin = unsuzYumusamasi(metin);
            }
        }
        if (metin.match(/[aı].$|[aı][bcçdfgğhjklmnprsştvwxyz'].$|[aı][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "ın";
        }
        if (metin.match(/[ei].$|[ei][bcçdfgğhjklmnprsştvwxyz'].$|[ei][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "in";
        }
        if (metin.match(/[ou].$|[ou][bcçdfgğhjklmnprsştvwxyz'].$|[ou][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "un";
        }
        if (metin.match(/[öü].$|[öü][bcçdfgğhjklmnprsştvwxyz'].$|[öü][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "ün";
        }

        return metin;
    }


    function _e(metin, ozel_isim_mi, yabanci_mi) { // Yönelme durumu eki:(-e / -a)
        if (metin.match(/.*[aeoueıiöü]$/i)) {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            }
            metin += "y";
        } else {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            } else if (!ozel_isim_mi && !yabanci_mi) {
                metin = unsuzYumusamasi(metin);
            }
        }
        if (metin.match(/(?=.*[aıou].$)|(?=.*[aıou]..$)(?=.*[bcçdfgğhjklmnprsştvwxyz'].$)|(?=.*[aıou]...$)(?=.*[bcçdfgğhjklmnprsştvwxyz]..$)(?=.*[bcçdfgğhjklmnprsştvwxyz].$)/i)) {
            metin += "a";
        }
        if (metin.match(/(?=.*[eiöü].$)|(?=.*[eiöü]..$)(?=.*[bcçdfgğhjklmnprsştvwxyz'].$)|(?=.*[eiöü]...$)(?=.*[bcçdfgğhjklmnprsştvwxyz]..$)(?=.*[bcçdfgğhjklmnprsştvwxyz].$)/i)) {
            metin += "e";
        }

        return metin;
    }


    function _i(metin, ozel_isim_mi, yabanci_mi) { // Belirtme durumu eki (-i / -ı / -u / -ü)
        if (metin.match(/.*[aeoueıiöü]$/i)) {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            }
            metin += "y";
        } else {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            } else if (!ozel_isim_mi && !yabanci_mi) {
                metin = unsuzYumusamasi(metin);
            }
        }
        if (metin.match(/[aı].$|[aı][bcçdfgğhjklmnprsştvwxyz'].$|[aı][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "ı";
        }
        if (metin.match(/[ei].$|[ei][bcçdfgğhjklmnprsştvwxyz'].$|[ei][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "i";
        }
        if (metin.match(/[ou].$|[ou][bcçdfgğhjklmnprsştvwxyz'].$|[ou][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "u";
        }
        if (metin.match(/[öü].$|[öü][bcçdfgğhjklmnprsştvwxyz'].$|[öü][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz].$/i)) {
            metin += "ü";
        }

        return metin;
    }


    function _de_den(metin, ek, ozel_isim_mi, yabanci_mi) { // Bulunma durumu eki: (-de / -da / -te / -ta) / Ayrılma (Çıkma) durumu eki: (-den / -dan / -ten / -tan)

        metin = metin;
        if (metin.match(/.*[çfhksştp]$/i)) {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            }
            if (ek !== "s")
                metin += "t";
        } else {
            if (ozel_isim_mi && !cogul_mu && !kesme_isareti) {
                metin = ozelIsim(metin);
                kesme_isareti = true;
            }
            if (ek !== "s")
                metin += "d";
        }
        if (ek !== "s" && metin.match(/[aıou].$|[aıou][bcçdfgğhjklmnprsştvwxyz'].$|[aıou][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz'].$|[aıou][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz'].$/i)) {
            metin += "a";
        } else if (ek !== "s" && metin.match(/[eiöü].$|[eiöü][bcçdfgğhjklmnprsştvwxyz'].$|[eiöü][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz'].$|[eiöü][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz][bcçdfgğhjklmnprsştvwxyz'].$/i)) {
            metin += "e";
        }

        if (ek === "s") {
            return metin + "s";
        } else if (ek === "dan" || ek === "den" || ek === "tan" || ek === "ten") {
            return metin + "n";
        } else {
            return metin;
        }
    }

    function ozelIsim(ozel_isim, cogul_mu) {
        if (!cogul_mu) {
            ozel_isim += "'";
        }
        return ozel_isim;
    }

    function ekleriSirala(ekler_dizisi) {
        var temp_array = [],
            ordered_array = [];

        for (var i = 0; i < ekler_dizisi.length; i++) {
            if (ekler_dizisi[i] === "ler" || ekler_dizisi[i] === "lar") {
                temp_array.push(ekler_dizisi[i]);
                ekler_dizisi.splice(i, 1);
            }
        }
        for (var it = 0; it < ekler_dizisi.length; it++) {
            if (ekler_dizisi[it] === "in" || ekler_dizisi[it] === "ın") {
                temp_array.push(ekler_dizisi[it]);
                ekler_dizisi.splice(it, 1);
            }
        }

        ordered_array = temp_array.concat(ekler_dizisi);
        return ordered_array;
    }

    function unsuzYumusamasi(metin) {
        metin = metin.replace(/[ç]$/i, "c");
        metin = metin.replace(/[p]$/i, "b");
        metin = metin.replace(/[t]$/i, "d");
        if (metin.match(/[aeıioöuü][k]$/i)) {
            metin = metin.replace(/k$/, "ğ");
        } else if (metin.match(/[bcçdfgğhjklmnprsştvwxyz][k]$/i)) {
            metin = metin.replace(/k$/, "g");
        }
        return metin;
    }
};
if ((window.location.host === 'www.endeksa.com' || window.location.host === 'preprod.endeksa.com') && window.location.href.indexOf('top=') === -1 && !window.isHeadless()) {

    // COOKIE YES MIGRATED TO GTM
    // !function (d, l, t, s) {
    //     t = d.createElement('script');
    //     t.defer = 1;
    //     t.id = 'cookieyes';
    //     t.type = 'text/javascript';
    //     // t.setAttribute('delay', l);
    //     t.src = l;
    //     s = d.getElementsByTagName('script')[0];
    //     s.parentNode.insertBefore(t, s);
    // }(document, 'https://cdn-cookieyes.com/client_data/600192bf797d3203041c165a/script.js');

    // TRIGGERED ON TAG MANAGER
    //!function (e, a, n, d, g) { e.dengage = e.dengage || function () { (e.dengage.q = e.dengage.q || []).push(arguments) }, d = a.getElementsByTagName("head")[0], (g = a.createElement("script")).async = 1, g.setAttribute('delay', 'https://pcdn.dengage.com/p/push/501/08bc4d75-52b1-4e9d-1249-b28ef2aecb37/dengage_sdk.js'), d.appendChild(g) }(window, document);

    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        // t.src = v;
        t.setAttribute('delay', v);
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }(window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '233175853836342');

    // (function (c, l, a, r, i, t, y) {
    //     c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
    //     t = l.createElement(r); t.async = 1;
    //     t.setAttribute("delay", "https://www.clarity.ms/tag/" + i);
    //     // t.src = "https://www.clarity.ms/tag/" + i;
    //     y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    // })(window, document, "clarity", "script", "h5s6ba9uqt");

    (function (w, u, d) {
        var i = function () { i.c(arguments); };
        i.q = [];
        i.c = function (args) { i.q.push(args); };
        var l = function () {
            var s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.setAttribute('delay', 'https://code.upscope.io/FxExxXKUYp.js');
            // s.src = 'https://code.upscope.io/FxExxXKUYp.js';
            var x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
        };
        if (typeof u !== "function") {
            w.Upscope = i;
            l();
        }
    })(window, window.Upscope, document);

    (function () {
        var gaconnect = document.createElement('script'); gaconnect.type = 'text/javascript'; gaconnect.async = true;
        gaconnect.src = 'https://track.gaconnector.com/gaconnector.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(gaconnect, s);
    })();

    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        // j.setAttribute('delay', 'https://www.googletagmanager.com/gtm.js?id=' + i + dl);
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-TTLPBLN');

    var tryNumber = 0;
    var interCookie = setInterval(function () {
        tryNumber++;
        if (typeof performBannerAction !== 'undefined') {
            if (window.refMobile) {
                performBannerAction("accept_all");
                clearInterval(interCookie);
            }
            else {
                clearInterval(interCookie);
            }
        }
        else if (tryNumber > 50) {
            clearInterval(interCookie);
        }
    }, 100);
}

window.dataLayer = window.dataLayer || [];

(function () {
    window.ybug_settings = { "id": "v81ja739j46sxzdm9523", widget_position: 'center', hide_launcher: true };
    var ybug = document.createElement('script'); ybug.type = 'text/javascript'; ybug.async = true;
    // ybug.src = 'https://widget.ybug.io/button/'+window.ybug_settings.id+'.js';
    ybug.setAttribute('delay', 'https://widget.ybug.io/button/' + window.ybug_settings.id + '.js');
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ybug, s);
})();

// ============================================================================
// PERFORMANCE MONITORING - Web Vitals & Resource Timing
// ============================================================================
(function () {
    'use strict';

    var host = window.location.host;
    var isProd = host === 'www.endeksa.com' || host === 'preprod.endeksa.com';

    if (!window.performance || !window.performance.timing) return;

    window.addEventListener('load', function () {
        setTimeout(function () {
            var t = performance.timing;

            var metrics = {
                dns: t.domainLookupEnd - t.domainLookupStart,
                tcp: t.connectEnd - t.connectStart,
                ttfb: t.responseStart - t.requestStart,
                response: t.responseEnd - t.responseStart,
                dom: t.domContentLoadedEventEnd - t.domContentLoadedEventStart,
                total: t.loadEventEnd - t.navigationStart
            };

            if (!isProd) {
                console.log('📊 Performance Metrics:', metrics);
                console.log('DNS: ' + metrics.dns + 'ms');
                console.log('TCP: ' + metrics.tcp + 'ms');
                console.log('TTFB: ' + metrics.ttfb + 'ms');
                console.log('Response: ' + metrics.response + 'ms');
                console.log('DOM: ' + metrics.dom + 'ms');
                console.log('Total Load: ' + metrics.total + 'ms');
            }

            if (window.gtag && metrics.total < 30000) {
                gtag('event', 'timing_complete', {
                    name: 'page_load',
                    value: Math.round(metrics.total),
                    event_category: 'Performance',
                    event_label: window.location.pathname
                });

                gtag('event', 'timing_complete', {
                    name: 'ttfb',
                    value: Math.round(metrics.ttfb),
                    event_category: 'Performance',
                    event_label: window.location.pathname
                });
            }

            if (window.performance.getEntriesByType) {
                var resources = performance.getEntriesByType('resource');
                var slowResources = resources
                    .filter(function (r) { return r.duration > 1000; })
                    .map(function (r) {
                        return {
                            name: r.name.split('/').pop(),
                            duration: Math.round(r.duration)
                        };
                    });

                if (slowResources.length > 0 && !isProd) {
                    console.warn('⚠️  Slow Resources (>1s):', slowResources);
                }
            }
        }, 0);
    });

    if ('PerformanceObserver' in window) {
        try {
            var lcpObserver = new PerformanceObserver(function (list) {
                var entries = list.getEntries();
                var lastEntry = entries[entries.length - 1];
                var lcp = lastEntry.renderTime || lastEntry.loadTime;

                if (!isProd) {
                    console.log('📈 LCP (Largest Contentful Paint):', Math.round(lcp) + 'ms');
                }

                if (window.gtag && lcp < 10000) {
                    gtag('event', 'web_vitals', {
                        name: 'LCP',
                        value: Math.round(lcp),
                        event_category: 'Web Vitals',
                        event_label: window.location.pathname
                    });
                }
            });
            lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });

            var fidObserver = new PerformanceObserver(function (list) {
                var entries = list.getEntries();
                entries.forEach(function (entry) {
                    var fid = entry.processingStart - entry.startTime;

                    if (!isProd) {
                        console.log('📈 FID (First Input Delay):', Math.round(fid) + 'ms');
                    }

                    if (window.gtag && fid < 1000) {
                        gtag('event', 'web_vitals', {
                            name: 'FID',
                            value: Math.round(fid),
                            event_category: 'Web Vitals',
                            event_label: window.location.pathname
                        });
                    }
                });
            });
            fidObserver.observe({ entryTypes: ['first-input'] });

            var clsValue = 0;
            var clsObserver = new PerformanceObserver(function (list) {
                var entries = list.getEntries();
                entries.forEach(function (entry) {
                    if (!entry.hadRecentInput) {
                        clsValue += entry.value;
                    }
                });
            });
            clsObserver.observe({ entryTypes: ['layout-shift'] });

            window.addEventListener('beforeunload', function () {
                if (!isProd && clsValue > 0) {
                    console.log('📈 CLS (Cumulative Layout Shift):', clsValue.toFixed(3));
                }

                if (window.gtag && clsValue < 1) {
                    gtag('event', 'web_vitals', {
                        name: 'CLS',
                        value: Math.round(clsValue * 1000),
                        event_category: 'Web Vitals',
                        event_label: window.location.pathname
                    });
                }
            });

        } catch (e) {
            if (!isProd) {
                console.log('Web Vitals monitoring not supported or failed:', e.message);
            }
        }
    }
})();

// ============================================================================
// SERVICE WORKER REGISTRATION & UPDATE HANDLING
// ============================================================================
(function () {
    'use strict';

    if (!('serviceWorker' in navigator)) {
        console.log('ℹ️ Service Worker not supported');
        return;
    }

    // Prevent duplicate setup (important for www.endeksa.com with GTM)
    if (window.__swSetupComplete) {
        console.log('ℹ️ SW already setup - skipping duplicate initialization');
        return;
    }
    window.__swSetupComplete = true;

    var updateAvailable = false;
    var newWorker = null;
    var refreshing = false;
    var updateCheckInProgress = false;
    var lastUpdateCheck = 0;
    var UPDATE_DEBOUNCE = 5000; // Don't process updates more than once per 5 seconds
    var host = window.location.host;
    var isDev = host.indexOf('localhost') !== -1 || host.indexOf('127.0.0.1') !== -1;
    var pageLoadTime = Date.now(); // Track when page loaded

    console.log('🌐 Service Worker Environment:');
    console.log('   Host:', host);
    console.log('   isDev:', isDev);
    console.log('   Update behavior: Auto-activate on page load, show notification mid-session');
    console.log('   💡 Updates detected within 3s of page load = auto-activate');

    window.addEventListener('load', function () {
        // Prevent duplicate registrations
        navigator.serviceWorker.getRegistration('/sw.js').then(function (existingReg) {
            if (existingReg) {
                console.log('✅ SW already registered, using existing');
                console.log('   Current state:', existingReg.active?.state);
                console.log('   Waiting:', existingReg.waiting?.state);
                console.log('   Installing:', existingReg.installing?.state);

                // ⚡ CRITICAL: Check if there's already a waiting worker on page load
                if (existingReg.waiting) {
                    console.log('⚡⚡⚡ UPDATE ALREADY WAITING ON PAGE LOAD! ⚡⚡⚡');
                    newWorker = existingReg.waiting;
                    updateAvailable = true;

                    // ⚡ AUTO-UPDATE ON PAGE LOAD
                    // Update waiting when page loads = auto-activate immediately
                    // (User loaded/refreshed, they want latest content)
                    console.log('🔄 Page load with waiting update - auto-activating...');
                    console.log('   (Update was waiting - activating on page load)');
                    refreshing = true;
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                    // controllerchange event will reload the page
                }

                setupUpdateListeners(existingReg);
                return existingReg;
            }

            // ⚡ CRITICAL: Register with updateViaCache: 'none' to bypass HTTP cache
            return navigator.serviceWorker.register('/sw.js', {
                updateViaCache: 'none'  // Always fetch fresh sw.js, never use HTTP cache
            }).then(function (r) {
                console.log('✅ SW registered (updateViaCache: none)');
                setupUpdateListeners(r);
                return r;
            });
        }).catch(function (e) {
            console.log('SW failed:', e);
        });
    });

    function setupUpdateListeners(r) {
        if (r._listenersSetup) {
            console.log('ℹ️ Update listeners already setup');
            return;
        }
        r._listenersSetup = true;

        // ⚡ CRITICAL: Attach updatefound listener BEFORE calling r.update()
        // This ensures we catch the event when it fires
        console.log('📡 Attaching updatefound listener...');

        // Listen for updates (attach this FIRST, before calling r.update())
        r.addEventListener('updatefound', function () {
            console.log('🔔 updatefound event fired!');

            // Debounce: Prevent rapid-fire update events (common with GTM/analytics)
            var now = Date.now();
            if (now - lastUpdateCheck < UPDATE_DEBOUNCE) {
                console.log('⏱️ Update event debounced - too soon after last check (' + (now - lastUpdateCheck) + 'ms)');
                return;
            }
            lastUpdateCheck = now;

            // Prevent multiple simultaneous update checks
            if (updateCheckInProgress) {
                console.log('ℹ️ Update check already in progress - skipping');
                return;
            }

            updateCheckInProgress = true;
            newWorker = r.installing;
            console.log('🔄 New version detected - installing...', newWorker ? 'Worker found' : 'No worker');

            if (!newWorker) {
                console.log('⚠️ No new worker found in r.installing!');
                updateCheckInProgress = false;
                return;
            }

            // Helper function to handle the update notification
            function handleUpdateReady() {
                if (navigator.serviceWorker.controller) {
                    // This is an UPDATE (existing controller means there's already a SW)
                    updateAvailable = true;
                    console.log('✅✅✅ NEW VERSION READY TO ACTIVATE! ✅✅✅');
                    console.log('   📍 Current controller:', navigator.serviceWorker.controller.scriptURL);
                    console.log('   📍 New worker:', newWorker.scriptURL);
                    console.log('   📍 Environment:', isDev ? 'Development' : 'Production');
                    console.log('   📍 Host:', host);

                    // ⚡ TIME-BASED AUTO-ACTIVATION
                    // If update detected within 3 seconds of page load, auto-activate
                    // This handles: hard refresh, regular refresh, first load
                    var timeSincePageLoad = Date.now() - pageLoadTime;
                    console.log('   📍 Time since page load:', timeSincePageLoad + 'ms');

                    if (timeSincePageLoad < 3000) {
                        // Update detected very soon after page load = user just loaded/refreshed
                        console.log('🔄 Update detected within 3s of page load - auto-activating...');
                        console.log('   (User just loaded/refreshed - no notification needed)');
                        refreshing = true;
                        newWorker.postMessage({ type: 'SKIP_WAITING' });
                        updateCheckInProgress = false;
                        return;
                    }

                    // Update detected later (user has been browsing) - show notification
                    console.log('📢 Update detected during browsing session - showing notification...');
                    console.log('   (User has been on page for ' + Math.round(timeSincePageLoad / 1000) + 's)');
                    try {
                        showUpdateNotification();
                        console.log('✅ showUpdateNotification() completed successfully');
                    } catch (err) {
                        console.error('❌ showUpdateNotification() failed:', err);
                    }

                    updateCheckInProgress = false;
                } else {
                    // This is a FIRST INSTALL (no existing controller)
                    console.log('✅ Service Worker installed for the first time (no update needed)');
                    console.log('   (No existing controller - this is the initial install)');
                    updateCheckInProgress = false;
                }
            }

            // ⚡ RACE CONDITION FIX: Check if worker is already installed
            // (state might have changed before we added the listener)
            if (newWorker.state === 'installed') {
                console.log('⚡ Worker already in "installed" state - handling immediately');
                handleUpdateReady();
            }

            // Listen for state changes
            newWorker.addEventListener('statechange', function () {
                console.log('🔄 SW state changed to:', newWorker.state);
                console.log('   Has controller?', !!navigator.serviceWorker.controller);
                console.log('   Update available?', updateAvailable);
                console.log('   Refreshing?', refreshing);

                if (newWorker.state === 'installed') {
                    handleUpdateReady();
                } else {
                    console.log('   State:', newWorker.state, '- waiting for "installed"...');
                }
            });
        });

        // ⚡ NOW that listener is attached, set up update checks
        console.log('✅ updatefound listener attached');

        // Check for updates - less aggressive in development
        if (!isDev) {
            // Production: Check every hour
            setInterval(function () {
                r.update().then(function () {
                    console.log('🔍 Periodic SW update check');
                });
            }, 3600000);

            // Check for updates when user returns to tab (but debounced)
            var visibilityTimer;
            document.addEventListener('visibilitychange', function () {
                if (!document.hidden) {
                    clearTimeout(visibilityTimer);
                    visibilityTimer = setTimeout(function () {
                        console.log('👀 Tab visible - checking for updates');
                        r.update();
                    }, 1000);
                }
            });
        } else {
            console.log('🔧 DEV MODE: Periodic update checks disabled');
        }

        // ⚡ CRITICAL: Check for updates IMMEDIATELY (now that listener is attached)
        console.log('🔍 Triggering immediate SW update check...');
        console.log('   Note: updateViaCache=none should bypass HTTP cache');

        setTimeout(function () {
            // Call update() to check for new sw.js
            r.update().then(function () {
                console.log('✅ Initial SW update check complete');

                // Log current state for debugging
                console.log('   Active:', r.active?.state);
                console.log('   Waiting:', r.waiting?.state);
                console.log('   Installing:', r.installing?.state);

                if (r.waiting) {
                    console.log('   ⚡ Waiting worker exists after update check!');
                } else if (r.installing) {
                    console.log('   🔄 Worker is installing...');
                } else {
                    console.log('   ℹ️ No update found (same version)');
                }
            }).catch(function (err) {
                console.log('⚠️ Update check failed:', err);
            });
        }, 2000); // 2 second delay to ensure SW is fully ready

        // ⚡ BACKUP MECHANISM: Poll for waiting worker (catches cases where updatefound doesn't fire)
        // This is a safety net for edge cases
        var pollCount = 0;
        var pollInterval = setInterval(function () {
            pollCount++;

            if (pollCount > 10) {
                // Stop polling after 20 seconds
                clearInterval(pollInterval);
                console.log('⏹️ Stopped polling for updates (no update found after 20 seconds)');
                return;
            }

            // Check if there's a waiting worker
            if (r.waiting && !updateAvailable) {
                console.log('⚡ POLLING: Found waiting worker that was missed by updatefound!');
                newWorker = r.waiting;
                updateAvailable = true;
                clearInterval(pollInterval);

                // ⚡ TIME-BASED CHECK: Auto-activate if within 3s of page load
                var timeSincePageLoad = Date.now() - pageLoadTime;
                if (timeSincePageLoad < 3000) {
                    console.log('🔄 POLLING: Within 3s of page load - auto-activating...');
                    refreshing = true;
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                } else {
                    console.log('📢 POLLING: Showing notification (user has been browsing)...');
                    showUpdateNotification();
                }
            }
        }, 2000); // Check every 2 seconds
    }

    // Handle SW controller change (new version activated)
    navigator.serviceWorker.addEventListener('controllerchange', function () {
        console.log('🔄 controllerchange event fired!');
        console.log('   Refreshing flag:', refreshing);
        console.log('   New controller:', navigator.serviceWorker.controller);

        if (refreshing) {
            console.log('✅ User confirmed reload - reloading page now...');
            window.location.reload();
        } else {
            console.log('ℹ️ Controller changed but not refreshing (might be first install or skipWaiting called)');
        }
    });

    // Handle messages from SW
    navigator.serviceWorker.addEventListener('message', function (e) {
        if (!e.data) return;

        if (e.data.type === 'CACHE_CLEARED') {
            console.log('✅ SW cache cleared');
        }

        // ⚡ SW_ACTIVATED: New version is active with cleared caches
        if (e.data.type === 'SW_ACTIVATED' && e.data.cacheCleared) {
            console.log('✅ New SW version activated (v' + e.data.version + ') - all caches cleared');
            console.log('   ℹ️ Page will reload via controllerchange event when user clicks "Reload Now"');
            // Note: No auto-reload here - user must click "Reload Now" button
            // The controllerchange event handler will reload the page
        }
    });

    // Show update notification (permanent toast with manual reload) - Multilingual
    function showUpdateNotification() {
        // Don't show update notification for bank users
        if (window.hasAllowance === 'bank') {
            console.log('ℹ️ Update notification suppressed for bank user');
            return;
        }

        // Prevent duplicate notifications
        if (document.getElementById('update-toast')) {
            console.log('ℹ️ Update notification already showing');
            return;
        }

        // Detect language from URL
        var lang = window.location.pathname.split('/')[1] || 'tr';

        var messages = {
            'tr': {
                title: '🎉 Yeni Sürüm Hazır!',
                message: 'Yeni özellikleri görmek için sayfayı yenileyin.',
                reloadBtn: 'Şimdi Yenile',
                dismissBtn: 'Daha Sonra'
            },
            'en': {
                title: '🎉 New Version Ready!',
                message: 'Reload the page to see new features.',
                reloadBtn: 'Reload Now',
                dismissBtn: 'Later'
            },
            'es-ES': {
                title: '🎉 Nueva Versión Lista!',
                message: 'Recarga la página para ver nuevas funciones.',
                reloadBtn: 'Recargar Ahora',
                dismissBtn: 'Más Tarde'
            },
            'pt-PT': {
                title: '🎉 Nova Versão Pronta!',
                message: 'Recarregue a página para ver novos recursos.',
                reloadBtn: 'Recarregar Agora',
                dismissBtn: 'Mais Tarde'
            }
        };

        var msg = messages[lang] || messages['tr'];

        var toast = document.createElement('div');
        toast.id = 'update-toast';
        toast.innerHTML = '<div style="position:fixed;top:20px;right:20px;background:#FF0550;color:#fff;padding:20px;border-radius:12px;box-shadow:0 4px 20px rgba(0,0,0,0.4);z-index:9999999;font-family:Inter,sans-serif;font-size:14px;max-width:340px;animation:slideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);"><strong style="display:block;margin-bottom:8px;font-size:16px;">' + msg.title + '</strong><p style="margin:0 0 16px 0;opacity:0.95;line-height:1.4;">' + msg.message + '</p><div style="display:flex;gap:8px;"><button id="reload-now-btn" style="flex:1;background:#fff;color:#FF0550;border:none;padding:10px 16px;border-radius:6px;cursor:pointer;font-weight:600;font-size:13px;transition:all 0.2s ease;font-family:Inter,sans-serif;">' + msg.reloadBtn + '</button><button id="dismiss-update-btn" style="background:rgba(255,255,255,0.15);color:#fff;border:none;padding:10px 16px;border-radius:6px;cursor:pointer;font-weight:500;font-size:13px;transition:all 0.2s ease;font-family:Inter,sans-serif;">' + msg.dismissBtn + '</button></div></div>';

        var style = document.createElement('style');
        style.textContent = '@keyframes slideIn{from{transform:translateX(400px);opacity:0}to{transform:translateX(0);opacity:1}}#reload-now-btn:hover{background:#f5f5f5;transform:translateY(-1px);box-shadow:0 2px 8px rgba(0,0,0,0.15)}#dismiss-update-btn:hover{background:rgba(255,255,255,0.25)}';
        document.head.appendChild(style);

        document.body.appendChild(toast);

        // ⚡ VERIFY the notification is actually visible
        setTimeout(function () {
            var check = document.getElementById('update-toast');
            if (check) {
                var rect = check.getBoundingClientRect();
                var innerDiv = check.querySelector('div');
                var computedStyle = window.getComputedStyle(innerDiv);

                console.log('🔍 NOTIFICATION VERIFICATION:');
                console.log('   ✅ Element exists in DOM:', !!check);
                console.log('   📍 Position:', 'top=' + rect.top + 'px, right=' + rect.right + 'px');
                console.log('   📍 Size:', rect.width + 'x' + rect.height + 'px');
                console.log('   📍 Z-index:', computedStyle.zIndex);
                console.log('   📍 Visibility:', computedStyle.visibility);
                console.log('   📍 Display:', computedStyle.display);
                console.log('   📍 Opacity:', computedStyle.opacity);
                console.log('   📍 Background:', computedStyle.backgroundColor);
                console.log('');

                if (rect.top < 0 || rect.right > window.innerWidth || rect.width === 0) {
                    console.warn('⚠️ NOTIFICATION MIGHT BE OFF-SCREEN!');
                    console.warn('   Window size:', window.innerWidth + 'x' + window.innerHeight);
                    console.warn('   Notification position:', rect);
                }

                if (computedStyle.zIndex < 999999) {
                    console.warn('⚠️ Z-index might be too low:', computedStyle.zIndex);
                }

                console.log('🎯 If you CANNOT see a red box in the top-right corner:');
                console.log('   1. Check browser zoom (should be 100%)');
                console.log('   2. Scroll to top of page');
                console.log('   3. Check if another element is covering it');
                console.log('   4. Try making window wider');
                console.log('   5. Run: document.getElementById("update-toast").scrollIntoView()');
            } else {
                console.error('❌ NOTIFICATION ELEMENT NOT FOUND IN DOM!');
                console.error('   Something removed it immediately after creation');
            }
        }, 200);

        // Reload button handler - triggers update and reload
        document.getElementById('reload-now-btn').addEventListener('click', function () {
            if (updateAvailable && !refreshing) {
                refreshing = true;
                console.log('🔄 User clicked "Reload Now" - activating new Service Worker...');
                toast.querySelector('div').innerHTML = '<div style="text-align:center;padding:10px;"><strong>' + (lang === 'tr' ? 'Yükleniyor...' : lang === 'es-ES' ? 'Cargando...' : lang === 'pt-PT' ? 'Carregando...' : 'Loading...') + '</strong></div>';

                // ⚡ CRITICAL: Tell the waiting Service Worker to activate
                if (newWorker && newWorker.state === 'installed') {
                    console.log('📤 Sending SKIP_WAITING message to new Service Worker...');
                    newWorker.postMessage({ type: 'SKIP_WAITING' });

                    // The controllerchange event will trigger the reload
                    // (see handler at line ~1872)
                } else if (navigator.serviceWorker.controller) {
                    // Fallback: clear caches and reload
                    console.log('⚠️ No waiting worker found, clearing caches and reloading...');
                    if ('caches' in window) {
                        caches.keys().then(function (names) {
                            return Promise.all(
                                names.map(function (name) {
                                    console.log('🗑️ Clearing cache:', name);
                                    return caches.delete(name);
                                })
                            );
                        }).then(function () {
                            console.log('✅ All caches cleared - hard reloading...');
                            window.location.reload(true);
                        }).catch(function () {
                            window.location.reload(true);
                        });
                    } else {
                        window.location.reload(true);
                    }
                } else {
                    // No SW at all - just reload
                    window.location.reload(true);
                }
            }
        });

        // Dismiss button handler - user can update later
        document.getElementById('dismiss-update-btn').addEventListener('click', function () {
            updateAvailable = false;
            refreshing = false;
            updateCheckInProgress = false;
            toast.remove();
            console.log('ℹ️ Update dismissed by user - won\'t show again this session');
        });
    }

    // Utility to clear SW cache
    window.clearSWCache = function () {
        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' });
        }
    };
})();
